
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.573 18H2.046v1.5a.5.5 0 00.5.5h10.027v-2zm0-1.99H.546a.5.5 0 01-.5-.5v-2a2 2 0 011.45-1.86l3.82-1.1a1 1 0 00.73-1V8a1 1 0 00-.4-.8 4 4 0 114.8 0 1 1 0 00-.4.8v1.332h-.378v3.913h2.905v2.765z"}}),_c('path',{attrs:{"d":"M10.107 9.752h9v3h-3v7h-3v-7h-3v-3z"}})])
          )
        }
      }
    